export function isUnrestricted(idea) {
    return !idea.restrictionCodes || idea.restrictionCodes.length === 0;
}